<template>
  <div class="wallet-panel with-traingle" @click.stop="preventDefault">
    <img src="../../assets/wallet/Shut.png" class="close" @click="emit('close')" />
    <!-- @click="walletPanelVisible = false" -->
    <h3 class="title">{{ $t('wallet.linkWallet') }}</h3>
    <!-- <div class="content">
      <div
        class="wallet-item wallet-item__evm row"
        @click="
          loginETH();
          walletPanelVisible = false;
        "
      >
        <div
          :class="[
            'wallet',
            'metamask',
            walletInfo[metamaskNetwork] ? 'active' : '',
          ]"
        >
          <img
            v-for="(item, index) in evmList"
            :key="`evm-${index}`"
            :class="[
              'evm',
              'vertical-middle',
              evmWalletLabel === item.name ? 'selected' : '',
            ]"
            :src="item.logo"
          />
        </div>
        <div class="wallet-info">
          <p class="wallet-info-title">{{ $t('emvWalletTitle') }}</p>
          <p class="wallet-info-desc">{{ $t('emvWalletDesc') }}</p>
        </div>
      </div>

      <div
        class="wallet-item"
        @click="
          login('TRX');
          walletPanelVisible = false;
        "
      >
        <div :class="['wallet', walletInfo['TRX'] ? 'active' : '', 'tronlink']">
          <img
            class="vertical-middle"
            :class="{
              connected: walletInfo['TRX'] && walletInfo['TRX'].address,
            }"
            :src="
              isDarkMode
                ? require('../assets/v2/trx_dark.png')
                : require('../assets/v2/trx.png')
            "
            alt=""
          />
        </div>
        <div class="wallet-info">
          <p class="wallet-info-title">Tronlink</p>
          <p class="wallet-info-desc">{{ `TRON ${$t('network')}` }}</p>
        </div>
      </div>

      <div
        class="wallet-item"
        @click="
          login('SOL');
          walletPanelVisible = false;
        "
      >
        <div :class="['wallet', walletInfo['SOL'] ? 'active' : '', 'phantom']">
          <img
            class="vertical-middle"
            :class="{
              connected: walletInfo['SOL'] && walletInfo['SOL'].address,
            }"
            :src="
              isDarkMode
                ? require('../assets/v2/sol_dark.png')
                : require('../assets/v2/sol.png')
            "
            alt=""
          />
        </div>
        <div class="wallet-info">
          <p class="wallet-info-title">Phantom</p>
          <p class="wallet-info-desc">Solana</p>
        </div>
      </div>

      <div
        class="wallet-item"
        @click="
          login('EOS');
          walletPanelVisible = false;
          clickTP = false;
        "
      >
        <div :class="['wallet', walletInfo['EOS'] ? 'active' : '', 'scatter']">
          <img
            class="vertical-middle"
            :class="{
              connected: walletInfo['EOS'] && walletInfo['EOS'].address,
            }"
            :src="
              isDarkMode
                ? require('../assets/v2/eos_dark.png')
                : require('../assets/v2/eos.png')
            "
            alt=""
          />
        </div>
        <div class="wallet-info">
          <p class="wallet-info-title">Scatter</p>
          <p class="wallet-info-desc">{{ `EOS ${$t('mainnet')}` }}</p>
        </div>
      </div>

      <div
        class="wallet-item"
        @click="
          login('IOST');
          walletPanelVisible = false;
          clickTP = false;
        "
      >
        <div :class="['wallet', walletInfo['IOST'] ? 'active' : '', 'iwallet']">
          <img
            class="vertical-middle"
            :class="{
              connected: walletInfo['IOST'] && walletInfo['IOST'].address,
            }"
            :src="
              isDarkMode
                ? require('../assets/v2/iost_dark.png')
                : require('../assets/v2/iost.png')
            "
            alt=""
          />
        </div>
        <div class="wallet-info">
          <p class="wallet-info-title">iWallet</p>
          <p class="wallet-info-desc">IOST</p>
        </div>
      </div>

      <div
        class="wallet-item"
        @click="
          login('DOT');
          walletPanelVisible = false;
        "
      >
        <div
          :class="['wallet', walletInfo['DOT'] ? 'active' : '', 'polkadot-js']"
        >
          <img
            class="vertical-middle"
            :class="{
              connected: walletInfo['DOT'] && walletInfo['DOT'].address,
            }"
            :src="
              isDarkMode
                ? require('../assets/v2/dot_dark.png')
                : require('../assets/v2/dot.png')
            "
            alt=""
          />
        </div>
        <div class="wallet-info">
          <p class="wallet-info-title">Polkadot.{js}</p>
          <p class="wallet-info-desc">Polkadot</p>
        </div>
      </div>
      <div
        v-if="inputSupportNetwork['KSM']"
        class="wallet-item"
        @click="
          login('KSM');
          walletPanelVisible = false;
        "
      >
        <div
          :class="['wallet', walletInfo['KSM'] ? 'active' : '', 'kusama-js']"
        >
          <img
            class="vertical-middle"
            :class="{
              connected: walletInfo['KSM'] && walletInfo['KSM'].address,
            }"
            :src="
              isDarkMode
                ? require('../assets/v2/ksm_dark.png')
                : require('../assets/v2/ksm.png')
            "
            alt=""
          />
        </div>
        <div class="wallet-info">
          <p class="wallet-info-title">Kusama</p>
          <p class="wallet-info-desc">Kusama</p>
        </div>
      </div>
      <div
        v-if="inputSupportNetwork['APTOS']"
        class="wallet-item"
        @click="
          login('APTOS');
          walletPanelVisible = false;
        "
      >
        <div
          :class="['wallet', walletInfo['APTOS'] ? 'active' : '', 'aptos-js']"
        >
          <img
            class="vertical-middle"
            :class="{
              connected: walletInfo['APTOS'] && walletInfo['APTOS'].address,
            }"
            :src="
              isDarkMode
                ? require('../assets/v2/aptos_dark.png')
                : require('../assets/v2/aptos.png')
            "
            alt=""
          />
        </div>
        <div class="wallet-info">
          <p class="wallet-info-title">Petra / Martian</p>
          <p class="wallet-info-desc">APTOS</p>
        </div>
      </div>

      <div
        v-if="inputSupportNetwork['TON']"
        class="wallet-item"
        @click="
          login('TON');
          walletPanelVisible = false;
        "
      >
        <div
          :class="['wallet', walletInfo['TON'] ? 'active' : '', 'ton-connect']"
        >
          <img
            class="vertical-middle"
            :class="{
              connected: walletInfo['TON'] && walletInfo['TON'].address,
            }"
            :src="
              isDarkMode
                ? require('../assets/v2/ton-wallet-dark.png')
                : require('../assets/v2/ton-wallet.png')
            "
            alt=""
          />
        </div>
        <div class="wallet-info">
          <p class="wallet-info-title">Ton Wallets</p>
          <p class="wallet-info-desc">TON</p>
        </div>
      </div>

      <div
        v-if="inputSupportNetwork['BTC']"
        class="wallet-item"
        @click="
          login('BTC');
          walletPanelVisible = false;
        "
      >
        <div
          :class="['wallet', walletInfo['BTC'] ? 'active' : '', 'btc-unisat']"
        >
          <img
            class="vertical-middle"
            :class="{
              connected: walletInfo['BTC'] && walletInfo['BTC'].address,
            }"
            :src="
              isDarkMode
                ? require('../assets/v2/unisat-dark.png')
                : require('../assets/v2/unisat.png')
            "
            alt=""
          />
        </div>
        <div class="wallet-info">
          <p class="wallet-info-title">Unisat</p>
          <p class="wallet-info-desc">BTC</p>
        </div>
      </div>
    </div> -->

    <div class="wallet-content">
      <WalletItem
        v-for="(wallet, index) in walletList"
        :key="index"
        :wallet="wallet"
        :class="['wallet-item-' + index]"
      />
    </div>

    <h3 class="title connected-title">
      {{
        `${$t('wallet.connected')} (${
          Object.keys(walletInfo).length
        })`
      }}
    </h3>

    <div class="connected-content">
      <div
        class="connected-item"
        v-for="(network, index) in Object.keys(walletInfo)"
        :key="`connected-wallet-${index}`"
      >
        <div class="connected-item-left" v-if="walletInfo[network]">
          <img class="logo" :src="walletInfo[network].icon" />
          <span>
            {{
              walletInfo[network]?.account?.slice(0, 6) +
              '...' +
              walletInfo[network]?.account?.slice(-6)
            }}
          </span>
        </div>
        <img
          class="delete"
          src="../../assets/wallet/delete.png"
          @click="disconnect(network)"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { storeToRefs } from 'pinia';
import { computed, reactive, defineEmits } from 'vue';
import { useI18n } from 'vue-i18n';
const { locale, t } = useI18n();
import { useCommonStore } from '../../stores/common';
const common = useCommonStore();
import { useWalletStore } from '../../stores/wallet';
const walletStore = useWalletStore();
const { walletInfo } = storeToRefs(walletStore);
import useDarkImg from '../../hooks/useDarkImg';
const { darkModeImg } = useDarkImg();

import { onboard } from '../../utils/onboard';
import { getWalletInfo } from '../../utils';
import { CHAIN_INFO_MAP } from '../../utils/constants';

import { clone } from 'lodash';

import WalletItem from './WalletItem.vue';

const emit = defineEmits(['close'])

const state = reactive({});

const tokenPocketImg = computed(() => {
  if (walletStore.evmWalletLabel === 'tokenpocket') {
    return require(`../../assets/wallet/tokenpocket${darkModeImg.value}.png`);
  } else {
    return require(`../../assets/wallet/tokenpocket-disabled${darkModeImg.value}.png`);
  }
});

const metamaskImg = computed(() => {
  if (walletStore.evmWalletLabel === 'metamask') {
    return require(`../../assets/wallet/metamask${darkModeImg.value}.png`);
  } else {
    return require(`../../assets/wallet/metamask-disabled${darkModeImg.value}.png`);
  }
});

const walletConnectImg = computed(() => {
  if (walletStore.evmWalletLabel === 'walletconnect') {
    return require(`../../assets/wallet/walletconnect${darkModeImg.value}.png`);
  } else {
    return require(`../../assets/wallet/walletconnect-disabled${darkModeImg.value}.png`);
  }
});

const coinbaseImg = computed(() => {
  if (walletStore.evmWalletLabel === 'coinbase') {
    return require(`../../assets/wallet/coinbase${darkModeImg.value}.png`);
  } else {
    return require(`../../assets/wallet/coinbase-disabled${darkModeImg.value}.png`);
  }
});

const trxImg = computed(() => {
  return require(`../../assets/wallet/trx${darkModeImg.value}.png`);
});

const evmList = computed(() => {
  const list = [
    {
      name: 'tokenpocket',
      logo: tokenPocketImg.value,
    },
    {
      name: 'metamask',
      logo: metamaskImg.value,
    },
    {
      name: 'walletconnect',
      logo: walletConnectImg.value,
    },
    {
      name: 'coinbase',
      logo: coinbaseImg.value,
    },
  ];
  let sortedList = list;
  if (walletStore.evmWalletLabel) {
    sortedList = list.sort((item1, item2) => {
      return item1.name !== walletStore.evmWalletLabel &&
        item2.name === walletStore.evmWalletLabel
        ? 1
        : -1;
    });
  }
  return sortedList;
});

const walletList = computed(() => {
  return [
    {
      walletIconList: evmList.value,
      walletName: t('wallet.emvWalletTitle'),
      walletDesc: t('wallet.emvWalletDesc'),
      network: 'EVM',
    },
    {
      walletIconList: [
        {
          name: 'TRX',
          logo: trxImg.value,
        },
      ],
      walletName: 'Tronlink',
      walletDesc: 'TRON Network',
      network: 'TRX',
    },
  ];
});

const preventDefault = (e) => {
  e.preventDefault();
};

const disconnect = (network) => {
  if (walletInfo.value[network]) {
    const isEVM = CHAIN_INFO_MAP[network] && CHAIN_INFO_MAP[network].isEVM;
    if (isEVM) {
      const [primaryWallet] = onboard.state.get().wallets;
      onboard.disconnectWallet({ label: primaryWallet.label });
    } else {
      switch (network) {
        case 'TON':
          // tonConnectUI.disconnect();
          break;
        default:
          break;
      }
    }
    setWalletInfo(network, false);
  }
};

const setWalletInfo = (network, isConnect, info) => {
  const wallets = getWalletInfo(walletInfo.value, network, false);
  walletStore.walletInfo = wallets;
};
</script>

<style lang="scss" scoped>
.wallet-panel {
  position: absolute;
  background: var(--wrap-bg);
  box-shadow: var(--wallet-panel-shadow);
  width: 430px;
  right: 0;
  top: 47px;
  border-radius: 12px;
  z-index: 99;
  padding: 26px 20px 30px;
  color: var(--color);
  box-sizing: border-box;

  &::after {
    right: 50px;
  }

  .close {
    display: none;
  }

  .title {
    font-size: 16px;
    font-weight: bold;
  }

  .wallet-content {
    margin-top: 10px;
    overflow: hidden;
    display: grid;
    grid-auto-columns: 190px 190px;
    gap: 10px;
    .wallet-item-0 {
      grid-column: span 2;
    }
  }

  .connected-title {
    margin: 16px 0 10px;
  }

  .connected-content {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    .connected-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 34px;
      background: var(--wallet-connected-bg);
      border: 1px solid var(--wallet-connected-border);
      border-radius: 30px;
      margin-top: 10px;
      padding: 0 10px 0 3px;
      .connected-item-left {
        display: flex;
        align-items: center;
        .logo {
          width: 28px;
          height: 28px;
        }
        span {
          margin-left: 6px;
          font-size: 14px;
          color: var(--color);
        }
      }
      .delete {
        width: 14px;
        height: 15px;
        cursor: pointer;
      }
    }
  }
}

@media screen and (max-width: 767px) {
  .wallet-panel {
    position: fixed;
    top: 0;
    bottom: 0;
    margin: auto;
    transform: translateY(-30px);
    height: fit-content;
    left: 16px;
    right: 16px;
    width: auto;
    box-shadow: none;
    border-radius: 20px;
    padding: 15px 15px 25px;

    &::after {
      display: none;
    }

    .close {
      display: inline-block;
      position: absolute;
      width: 16px;
      right: 15px;
      top: 15px;
      z-index: 9999;
      cursor: pointer;
    }
    .title {
      font-size: 13px;
    }
    .wallet-content {
      grid-template-columns: calc(50% - 4px) calc(50% - 4px);
      gap: 8px;
    }
    .connected-title {
      margin-top: 15px;
    }
    .connected-item {
      float: none;
      margin-top: 8px;
      width: 100%;
    }
  }
}
</style>
